<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Edição de produto</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading page v-if="loading" />            

            <ResourceNotFound
                v-if="!loading && loadError"
                resource="produto"
                :identifier="$route.params.id"
                list-path="/produtos"
                list-label="Voltar para produtos"
                :kind="loadErrorKind"
                :error-message="loadErrorMessage"
                @retry="load" />

            <ProductFormCmp 
                v-if="!loadError"
                :product="product"
                :loading="loading"
                :channel-list="channelList"
                :product-descriptions-editor="productDescriptionsEditor" />
        </div>
    </div>
</template>

<script>
import productService from "@/product/services/ProductService";
import { ProductFormModel } from '@/product/models/ProductFormModel';
import { ProductModel } from '@/product/models/ProductModel';
import ProductFormCmp from '@/product/components/ProductFormCmp'
import { mapState } from 'vuex';
import channelService from '../../channel/services/ChannelService';
import ResourceLoadError from '../../utils/mixins/ResourceLoadError'

export default {
    name: 'ProductModificationView',
    components: {
        ProductFormCmp,
    },
    data() {
        return {
            loading: false,
            product: new ProductFormModel(),
            channelList: [],
            productDescriptionsEditor: {
                main: '',
                short: '',
                long: '',
            },
        }
    },
    mixins: [
        ResourceLoadError,
    ],
    mounted() {
        this.load()
    },
    methods: {
        async load() {
            this.loading = true;
            this.loadError = null

            try {
                const result = await Promise.all([
                    productService.getProductById(this.$route.params.id),
                    channelService.getChannels(),
                ])

                const productNormalized = ProductModel.normalizeV1(result[0], this.subscriber)
                this.channelList = result[1]

                this.productDescriptionsEditor.main = productNormalized.getDescriptionWithLineBreaks()
                this.productDescriptionsEditor.short = productNormalized.getDescriptionShortWithLineBreaks()
                this.productDescriptionsEditor.long = productNormalized.getDescriptionLongWithLineBreaks()
                this.product = new ProductFormModel(productNormalized)

                if (!this.product.hasVariations() && !this.product.hasSkuCode()) {
                    const {skuCode} = await productService.getNewSkuCode()
                    this.product.setSkuCode(skuCode)
                }
            } catch(e) {
                this.loadError = e
            }

            this.loading = false;
        },
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
        breadcrumbList() {
            const id = this.$route.params.id

            // sem produto, o "Detalhes" levaria para outro "nao encontrado"
            if (this.loadError) {
                return [
                    { id: 0, description: 'Produtos', path: '/produtos' },
                    { id: 1, description: `Produto #${id}`, path: '' },
                ]
            }

            return [
                { id: 0, description: 'Produtos', path: '/produtos' },
                { id: 1, description: `Detalhes`, path: `/produtos/${id}` },
                { id: 2, description: `Edição de #${id}`, path: '' },
            ]
        },
    },
}
</script>